module.exports = __webpack_public_path__ + "img/menu-daily-check-active.4f16fb0d.svg";